<template>
    <article class="h-full"
             :class="{ 'p-20 md:p-30 lg:p-40 has-background': backgroundColor }"
             :style="elementStyle">
        <div>
            <div>
                <SmartHeadline v-if="content.headline"
                               :level="isFirstBlock ? 'h1' : 'h2'"
                               :style-as-h1="isFirstBlock"
                               class="mb-10">
                    {{ content.headline }}
                </SmartHeadline>

                <section ref="htmlContentRef"
                         v-delegate-html-links
                         v-delegate-on-img-error
                         class="wysiwyg text-block"
                         v-html="bodyText"/>
                <CallToAction v-if="content.callToAction"
                              class="cta--rounded mt-20"
                              :hex-color="content.callToActionColor"
                              :text="content.callToAction.name"
                              :href="content.callToAction.url"
                              :target="content.callToAction.target"/>
            </div>
        </div>
    </article>
</template>

<script setup lang="ts">
import { computed, ComputedRef, StyleValue, PropType, onMounted, onBeforeUnmount, ref, Ref } from 'vue';
import { TextBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import tableHtmlService from './tableHtml.service';

const props = defineProps({
    content: { type: Object as PropType<Partial<TextBlockViewModel>>, required: true },
    isFirstBlock: { type: Boolean, required: false, default: false }
});

const backgroundColor = computed(() => props.content.backgroundColor ? `#${props.content.backgroundColor}` : null);
const elementStyle: ComputedRef<StyleValue> = computed(() => backgroundColor.value
    ? { backgroundColor: backgroundColor.value }
    : {} );

const bodyText = computed(() => {
    return tableHtmlService.wrapTableInOuterDivs(props.content.bodyText || '');
});

const htmlContentRef: Ref<HTMLElement | null> = ref(null);

onMounted(() => {
    if (htmlContentRef.value) {
        tableHtmlService.registerTableOverflow(htmlContentRef.value);
    }
});

onBeforeUnmount(() => {
    if (htmlContentRef.value) {
        tableHtmlService.unregisterTableOverflow(htmlContentRef.value);
    }
});
</script>
